import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from 'lib/ng2-sapmp/src/providers/utility.service';
import { BreadCrumbService, StepIndicatorModel, StepIndicatorService, GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components';
import { Router, ActivatedRoute } from '@angular/router';
import { sample } from 'rxjs/operators';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { FormControl, FormGroup } from '@angular/forms';
import * as XLSX from 'xlsx';
import { CareComponentService } from 'app/pages/care/shared/providers/care.service';

@Component({
  selector: 'app-enrollment-options',
  templateUrl: './enrollment-options.component.html',
  styleUrls: ['./enrollment-options.component.scss'],
  providers: [CareComponentService]
})
export class EnrollmentOptionsComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  uploadFileName: any;
  uploadedFile: any;
  fileNameStatus: boolean = false;
  stepIndicator: StepIndicatorModel[];
  gridOptions: GridOptionsModel;
  selectAccounts: any;
  efotaNotEnrolledFans = [];
  isFanSelected = false;
  selectedFanList = [];
  userEnrollmentType: string;
  userEnrollmentTypes = [];
  userData: any;
  userPhoneNumber: any;
  userEmail: any;
  stateValues = [];
  timeZoneValues = [];
  timeOfDay = [{"name":"Morning","value":"Morning"},{"name":"Afternoon","value":"Afternoon"}];
  notificationType: any = '';
  @ViewChild('emailNotification') emailNotification: ElementRef;
  @ViewChild('textMessageNotification') textMessageNotification: ElementRef;
  showUpload = false;
  showAvailableTime = false;
  contactName: any = '';
  stateName: any = '';
  timeZoneName: any = {
    "name" : "",
    "value" : ""
  };
  contactNumber: any = '';
  isContactNameInvalid = false;
  isCsvFileEmpty = false;
  isCtnNumberInvalid = false;
  isImeiNumberInvalid = false;
  isCtnOnlyPresent = false;
  isImeiOnlyPresent = false;
  isCtnAndImeiInvalid = false;
  isFileSizeInvalid = false;
  isFileExtInvalid = false;
  isCtnNotInFirstTwoColumns = false;
  banNumber: any;
  isBanNumberInvalid = false;
  selectedFan: any;
  isDisabled = false;
  isBanNumberEmpty = true;
  dayTimeSlot: any;
  dayTimeSlotName: any = {
    "name" : "",
    "value" : ""
  };
  ctnNumbersStatus = false;
  userEnrollmentTypeStatus = false;
  isContactNumberInvalid = false;
  isContactNumberEmpty = true;
  isContactNameEmpty = true;
  companyName: any = '';
  environmentPortal: any = '';
  ctnList = [];
  isFansZero = false;
  enrolledData: any;
  ctnRegex = new RegExp("^[2-9][0-9]{9}$");
  imeiRegex = new RegExp("^[0-9]{15}$|^[0-9]{16}$");
  spaceRegex = new RegExp("^[ ]+$");
  uploadFinalStatus = false;
  staticTCUrl : any;

  form = new FormGroup({
    billingAccount: new FormControl(),
    contactName1: new FormControl(),
    contactNumber1: new FormControl(),
    timePeriod: new FormControl(),
    zipCode: new FormControl()
  })
  banNumberRegex = new RegExp("^[0-9]{8}$|^[0-9]{9}$|^[0-9]{12}$|^[0-9]{13}$");
  contactNameRegex = new RegExp("^[a-zA-Z\- ]+$");
  contactNumberRegex = new RegExp("^[0-9]+$");
  uploadedFileName: any;
  isFirstnetCustomer: boolean = false;

  constructor(private utilityService: UtilityService, private careService: CareComponentService, private breadCrumbService: BreadCrumbService, private router: Router, private stepIndicatorService: StepIndicatorService,
    private route: ActivatedRoute) {
      if (sessionStorage.getItem('SAPMP_ENV_PORTAL') == "fnabc") {
        this.isFirstnetCustomer = true;
      }
      else {
        this.isFirstnetCustomer = false;
      }
     }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Product Info Request', routerLink: '/fiveg/enrollment' });
    this.selectAccounts = this.route.snapshot.data.pageData.fivegenrollmentselectaccounts;
    this.efotaNotEnrolledFans = [];
    this.efotaNotEnrolledFans = JSON.parse(sessionStorage.getItem('efotaNotEnrolledFanList'));
    this.userData = JSON.parse(sessionStorage.getItem('user'));
    this.userData = this.userData.user;
    this.isFansZero = (this.userData.fanList.length == 0) ? true : false;
    this.userPhoneNumber = this.userData.contactPhoneNumber;
    this.userEmail = this.userData.emailAddress;
    this.selectedFanList.length = 0;
    this.userEnrollmentTypes.length = 0;
    this.isContactNumberInvalid = false;
    this.isContactNameInvalid = false;
    this.isContactNumberEmpty = true;
    this.isContactNameEmpty = true;
    for (let i = 0; i < this.selectAccounts.states.length; i++) {
      this.stateValues.push(this.selectAccounts.states[i]);
    }
    for (let i = 0; i < this.selectAccounts.timeZones.length; i++) {
      this.timeZoneValues.push(this.selectAccounts.timeZones[i]);
    }
    this.userData.fanList.sort();
    this.selectAccounts.grid.gridData = this.userData.fanList;
    this.gridOptions = this.selectAccounts.grid;
    this.gridOptions.gridData = this.selectAccounts.grid.gridData;
    this.gridOptions.Paginations.totalRecords = this.gridOptions.gridData.length;
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    if (sessionStorage.getItem('SAPMP_ENV_PORTAL') === "myatt") {
      this.environmentPortal = "MyATT-ABC";
    }
    else if (sessionStorage.getItem('SAPMP_ENV_PORTAL') === "fnabc") {
      this.environmentPortal = "FirstNet-ABC";
    }
    else {
      this.environmentPortal = "Premier-ABC";
    }
    this.enrolledData = [];
    this.enrolledData = JSON.parse(sessionStorage.getItem('newFivegEnrollment'));
    if (this.enrolledData) {
      this.contactName = this.enrolledData.customerName;
      if(this.contactName.length > 0) {
        this.isContactNameEmpty = false;
        this.isContactNameInvalid = false;
      }
      this.contactNumber = this.enrolledData.alternateCustomerPhoneNumber;
      if(this.contactNumber.length > 0) {
        this.isContactNumberEmpty = false;
        this.isContactNumberInvalid = false;
      }
      if (this.enrolledData.bestTimeToContact != "Not Specified") {
        this.showAvailableTime = true;
        let timeArr = this.enrolledData.bestTimeToContact.split(",");
        this.timeZoneName = {
          "name": timeArr[0],
          "value": timeArr[0]
        };
        this.dayTimeSlotName = {
          "name": timeArr[1],
          "value": timeArr[1]
        };
      }
      else {
        this.showAvailableTime = false;
      }
      this.selectedFanList = Object.keys(this.enrolledData.fanList);
      this.userEnrollmentTypes = this.enrolledData.serviceRequested;
    }
    this.staticTCUrl = this.selectAccounts.termsAndConditionsURL;
  }

  checkBanFormat() {
    if (this.banNumberRegex.test(this.banNumber)) {
      this.isBanNumberInvalid = false;
      this.isBanNumberEmpty = false;
    }
    else if (this.banNumber == "") {
      this.isBanNumberInvalid = false;
      this.isBanNumberEmpty = true;
    }
    else {
      this.isBanNumberInvalid = true;
      this.isBanNumberEmpty = false;
    }
  }

  checkContactNameFormat() {
    if (this.contactNameRegex.test(this.contactName)) {
      this.isContactNameInvalid = false;
      this.isContactNameEmpty = false;
    }
    else if (this.contactName == "") {
      this.isContactNameInvalid = false;
      this.isContactNameEmpty = true;
    }
    else {
      this.isContactNameInvalid = true;
      this.isContactNameEmpty = false;
    }
  }

  checkContactNumberFormat() {
    if (this.contactNumber.length == 12) {
      this.isContactNumberInvalid = false;
      this.isContactNumberEmpty = false;
    }
    else if (this.contactNumber == "") {
      this.isContactNumberInvalid = false;
      this.isContactNumberEmpty = true;
    }
    else {
      this.isContactNumberInvalid = true;
      this.isContactNumberEmpty = false;
    }
  }



  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  setOption(option) {
    if(this.userEnrollmentTypes.includes(option)) {
      this.userEnrollmentTypes = this.userEnrollmentTypes.filter(str => str !== option);
    }
    else {
      this.userEnrollmentTypes.push(option);
    }
    console.log(this.userEnrollmentTypes);
  }

  resetValue() {
    this.fileInput.nativeElement.value = "";
    return true;
  }

  ngDoCheck() {
      if (this.selectedFanList.length > 0 && this.userEnrollmentTypes.length > 0 && !this.isContactNameInvalid && !this.isContactNameEmpty && !this.isContactNumberInvalid && !this.isContactNumberEmpty
        && (this.timeZoneName.value.length > 0 && this.dayTimeSlot && typeof this.dayTimeSlot !== "undefined")) {
        this.isDisabled = false;
      }
      else {
        this.isDisabled = true;
      }
    }

  onRowClick(event) {
    this.selectedFan = event;
      if(this.selectedFanList.includes(event)) {
        this.selectedFanList = this.selectedFanList.filter(str => str !== event);
      }
      else {
        this.selectedFanList.push(event);
      }
    console.log(this.selectedFanList);
  }

  selectState(event) {
    this.stateName = event;
  }

  selectTimeZone(event) {
    this.timeZoneName = event;
    this.showAvailableTime = true;
  }


  selectTimeDay(event) {
    this.dayTimeSlotName = event;
    this.dayTimeSlot = event.value;

  }


  setNotification(event) {
    if (this.emailNotification.nativeElement.checked == true && this.textMessageNotification.nativeElement.checked == true) {
      this.notificationType = "Both";
    }
    else if (this.emailNotification.nativeElement.checked == true && this.textMessageNotification.nativeElement.checked == false) {
      this.notificationType = "Email";
    }
    else if (this.emailNotification.nativeElement.checked == false && this.textMessageNotification.nativeElement.checked == true) {
      this.notificationType = "TextMessage";
    }
    else {
      this.notificationType = "";
    }
  }

  continueToNext() {
    this.contactNumber = this.contactNumber.replaceAll(".","");
    let selectedFanNameList = {};
    for(let i=0 ; i<this.selectedFanList.length ; i++) {
      for(let j=0 ; j<this.userData.fans.length ; j++) {
        if(this.selectedFanList[i] == this.userData.fans[j].fanId) {
          selectedFanNameList[this.selectedFanList[i]] = this.userData.fans[j].fanName;
        }
      }
    }
    let timePeriodValue;
    for (let i = 0; i < this.userData.fans.length; i++) {
      if (this.selectedFan == this.userData.fans[i].fanId) {
        this.companyName = this.userData.fans[i].fanName;
        break;
      }
    }
    
    if (this.timeZoneName.value.length == 0 && !this.dayTimeSlot) {
      timePeriodValue = "Not Specified";
    }
    else if (this.timeZoneName.value.length > 0 && !this.dayTimeSlot) {
      timePeriodValue = this.timeZoneName.value;
    }
    else if (this.timeZoneName.value.length == 0 && this.dayTimeSlot) {
      timePeriodValue = this.dayTimeSlot;
    }
    else {
      timePeriodValue = this.timeZoneName.value + ',' + this.dayTimeSlot;
    }
    let data =
    {
      "customerName": this.contactName,
      "customerPhoneNumber": this.userPhoneNumber,
      "alternateCustomerPhoneNumber": this.contactNumber,
      "emailAddress": this.userEmail,
      "bestTimeToContact": timePeriodValue,
      "fanList": selectedFanNameList,
      "serviceRequested": this.userEnrollmentTypes,
      "requestorName": this.userData.firstName + " " + this.userData.lastName,
      "requestorPhoneNumber": this.userPhoneNumber
      }
      sessionStorage.setItem('newFivegEnrollment', JSON.stringify(data));
      this.router.navigate(['fiveg/enrollment/review']);
    }

  gotoLearn() {
    sessionStorage.setItem('backToLearn', 'true');
    this.router.navigate(['learn/efota']); 
  }

}
